import { QueryClient } from "@tanstack/react-query";
import { DEFAULT_QUERY_OPTIONS } from "./config";

/** Factory QueryClient — dipakai per-render di provider agar aman untuk SPA. */
export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: { queries: DEFAULT_QUERY_OPTIONS },
  });
}
